import { ILicenseOption } from '@store/campaigns'
import { IPurchaseOrder } from '@store/purchaseOrders'
import { CreditManagementPaymentMethodPurchaseOrder } from './PurchaseOrder'

interface IProps {
  licenseOption: ILicenseOption
  onSelectPurchaseOrders: (purchaseOrderIds: IPurchaseOrder[]) => void
}

export const CreditManagementPaymentMethodWrapper = ({
  licenseOption,
  onSelectPurchaseOrders,
}: IProps) => {
  return (
    <CreditManagementPaymentMethodPurchaseOrder
      licenseOption={licenseOption}
      onSelectPurchaseOrders={onSelectPurchaseOrders}
    />
  )
}
